module.exports = __webpack_public_path__ + "img/jgcx_item.a082e5bb.png";